import Hashids from 'hashids';

const hashids = new Hashids(
  process.env.REACT_APP_ENCRYPT_SALT,
  Number(process.env.REACT_APP_ENCRYPT_PADDING)
);

/**
 * @param {number} id
 */
export const encryptId = id => hashids.encode(id);

/**
 * @param {string} hash
 * @param {boolean} [throwErr]
 */
export const decryptId = (hash, throwErr = false) => {
  const decoded = hashids.decode(hash);
  if (throwErr && decoded.length === 0) {
    const error = new Error('Invalid reference passed: The reference was changed or modified.');
    error.name = 'Invalid hash';
    throw error;
  } else {
    return decoded;
  }
};
